import { usePathname } from "expo-router";
import {
  createContext,
  useEffect,
  useMemo,
  type PropsWithChildren,
} from "react";

import useAnalytics from "$src/core/hooks/use-analytics";
import Analytics from "$src/core/services/analytics/analytics";
import type {
  Event,
  DefaultParams,
} from "$src/core/services/analytics/analytics";

type AnalyticsContextValue = {
  setUserProperty: (name: string, value: string) => void;
  trackEvent: (event: Event & Partial<DefaultParams>) => void;
};

const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);

const ScreenViewTracker = () => {
  const pathname = usePathname();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent("screen_view", {
      screen_name: pathname.split("/").pop() ?? "",
      screen_route: pathname,
    });
  }, [trackEvent, pathname]);

  return null;
};

const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  const value = useMemo(
    () => ({
      trackEvent: Analytics.trackEvent,
      setUserProperty: Analytics.setUserProperty,
    }),
    [],
  );

  return (
    <AnalyticsContext.Provider value={value}>
      <ScreenViewTracker />
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
